import { constants, typographyStyles } from "@newsela/angelou";

import { dangerRedWithOpacity } from "@/angelouCE/utils/constants";

const { colors } = constants;

const red = colors.status.danger[600];

const { heading6Obj } = typographyStyles;

export const rootCss = {
  ...heading6Obj,
  display: "flex",
  backgroundColor: dangerRedWithOpacity,
  borderRadius: "8px",
  marginBottom: "24px",
  padding: "16px",
};

export const iconCss = {
  width: 24,
  height: 24,
  marginRight: "8px",
  path: {
    fill: red,

    "&:first-of-type": {
      stroke: red,
    },
  },
};

export const buttonCss = {
  ...heading6Obj,
  color: red,
  padding: 0,
  fontWeight: "normal",
  textDecoration: "underline",
};

export const textCss = {
  margin: 0,
  color: red,
};
